"use client";

import { DOCS } from "@/lib/constants";
import MobileTierGrid from "@/components/sections/products/mobile-proxies/pricing-tiers/tier-grid";

// German clone of mobile-proxies/pricing-cards (hideHeader=false, asHero=false
// variant only — the page-level pricing hero isn't used here). Reuses the
// exact same live MobileTierGrid (fetches real pricing data; numbers are
// locale-agnostic) with translated surrounding copy.
export default function MobilePricingCardsDe() {
  return (
    <section
      id="pricing-plans"
      className="full-bleed band-wash border-border py-section relative overflow-y-clip border-b"
      aria-labelledby="pricing-cards-heading"
    >
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <p className="text-muted-foreground mb-3 text-sm font-medium">Plan wählen</p>
          <h2
            id="pricing-cards-heading"
            className="text-foreground mb-4 text-3xl font-bold tracking-tight sm:text-4xl"
          >
            Flexible Mobile-Proxy-Preise.
          </h2>
          <p className="text-muted-foreground light:text-foreground/80 text-lg leading-relaxed">
            Pay-per-GB für Premium-Mobile-IPs zu einem festen Satz. Jederzeit skalieren — keine
            Vertragsstrafen, keine Verpflichtungen.
          </p>
        </div>

        <div className="mx-auto max-w-6xl">
          <MobileTierGrid />

          <p className="text-muted-foreground mt-6 text-center text-sm">
            Alle Plandetails?{" "}
            <a
              href={DOCS.mobilePerGbPlan}
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground font-medium underline underline-offset-4 transition-opacity hover:opacity-80"
            >
              Per-GB-Dokumentation lesen
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
}
